import {
  ISideEffectHandler,
  SideEffectHandlerParams,
} from "./SideEffectHandler";
import { PieceType } from "../../../types";
import { EventType, SelectPieceEvent } from "../../../const";

export class BonusTurnHandler implements ISideEffectHandler {
  handleSideEffect(params: SideEffectHandlerParams): void {

    if (params.sideEffects.length === 0) return;

    // Process each bonus turn side effect
    params.sideEffects.forEach((sideEffect) => {
      // Each BonusTurn side effect should have exactly one piece (the piece that gets the bonus turn)
      if (sideEffect.piecesToEffect.length !== 1) {
        throw new Error("BonusTurn side effect must target exactly one piece");
      }

      const bonusTurnPiece = sideEffect.piecesToEffect[0];

      // Grant the bonus turn to the piece
      params.movementManager.getGameStateManager().grantBonusTurn(bonusTurnPiece);


      // Auto-select the piece for the bonus turn (for virus and penguin pieces)
      if (bonusTurnPiece.type === PieceType.Virus || bonusTurnPiece.type === PieceType.Penguin) {
        setTimeout(() => {
          // GUARD: Bonus turn may have already been consumed by the time this fires
          // (e.g., bot completed its bonus turn move before the 300ms elapsed).
          // Emitting a stale selectPiece event would lock the opponent's UI on an enemy piece.
          const currentGameState = params.movementManager.getGameStateManager().getGameState();
          if (currentGameState.activeBonusTurnPieceId !== bonusTurnPiece.id) {
            return;
          }

          // Find the current position of the piece
          const piecePosition = params.movementManager.getGameStateManager().findPiecePosition(bonusTurnPiece);

          if (piecePosition) {
            // CRITICAL FIX: Check if piece has any valid moves before locking selection
            // If Virus has NO infection moves, don't lock selection (auto-end will trigger)
            const validMoves = bonusTurnPiece.getValidMovesForPiece(
              params.movementManager.getGameStateManager().getBoardState(),
              piecePosition,
              params.movementManager.getGameStateManager().getGameState().isLightTurn,
              params.movementManager.getGameStateManager()
            );

            // Only lock selection if there are actual moves available
            const shouldLock = validMoves.length > 0;

            const selectEvent: SelectPieceEvent = {
              type: EventType.selectPiece,
              pieceId: bonusTurnPiece.id,
              position: piecePosition,
              lockSelection: shouldLock,
            };

            const pieceTypeEmoji = bonusTurnPiece.type === PieceType.Virus ? '🦠' : '🐧';

            // Emit event through EventManager (no more direct DOM manipulation)
            params.movementManager.getEventManager().emitEvent(selectEvent);
          }
        }, 300); // 300ms delay to ensure the move animation completes
      }
    });
  }
}